import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { AxiosResponse } from "axios";
import { IGetRowsParams } from "ag-grid-community";
import { GridPaginatedResponse } from "../../interfaces/GridPaginatedResponse";

const handleGridPaginatedResponse =
  <T>(gridRef: RefObject<AgGridReact<T> | null>, params: IGetRowsParams) =>
  (response: AxiosResponse<GridPaginatedResponse<T>>) => {
    if (response.data.responseObject) {
      const { items, total } = response.data.responseObject;
      if (gridRef.current) {
        const gridApi = gridRef.current.api;
        if (total && items?.length > 0) {
          gridApi.hideOverlay();
        } else {
          gridApi.showNoRowsOverlay();
        }
      }

      params.successCallback(items, total);
    } else {
      if (gridRef.current) {
        const gridApi = gridRef.current.api;
        gridApi.showNoRowsOverlay();
      }
      params.successCallback([]);
    }
  };

export default handleGridPaginatedResponse;
